// proto/v2/connector/connector.proto
//
// Connector credential management over WS — Wave 3a HTTP→WS migration.
// Previously served over HTTP at /api/v1/connectors/* (see
// internal/workflow/connectors/api.go). Credentials are stored encrypted in
// the per-user Badger settings.db via CredentialStore; moving to WS inherits
// the session encryption envelope for credential-in-flight protection.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file connector/connector.proto (package lvdr.v2.connector, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file connector/connector.proto.
 */
export const file_connector_connector: GenFile = /*@__PURE__*/
  fileDesc("Chljb25uZWN0b3IvY29ubmVjdG9yLnByb3RvEhFsdmRyLnYyLmNvbm5lY3RvciJFCg5Db25uZWN0b3JQYXJhbRIMCgRuYW1lGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEhAKCHJlcXVpcmVkGAMgASgIImcKD0Nvbm5lY3RvckFjdGlvbhIMCgRuYW1lGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEjEKBnBhcmFtcxgDIAMoCzIhLmx2ZHIudjIuY29ubmVjdG9yLkNvbm5lY3RvclBhcmFtIoIBCglDb25uZWN0b3ISCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRIRCglhdXRoX3R5cGUYBCABKAkSMwoHYWN0aW9ucxgFIAMoCzIiLmx2ZHIudjIuY29ubmVjdG9yLkNvbm5lY3RvckFjdGlvbiK7AQoUQ29ubmVjdG9yQ3JlZGVudGlhbHMSEQoJYXV0aF90eXBlGAEgASgJEhQKDGFjY2Vzc190b2tlbhgCIAEoCRIVCg1yZWZyZXNoX3Rva2VuGAMgASgJEg8KB2FwaV9rZXkYBCABKAkSEQoJc210cF9ob3N0GAUgASgJEhEKCXNtdHBfcG9ydBgGIAEoBRIVCg1zbXRwX3VzZXJuYW1lGAcgASgJEhUKDXNtdHBfcGFzc3dvcmQYCCABKAkiFwoVTGlzdENvbm5lY3RvcnNSZXF1ZXN0IkoKFkxpc3RDb25uZWN0b3JzUmVzcG9uc2USMAoKY29ubmVjdG9ycxgBIAMoCzIcLmx2ZHIudjIuY29ubmVjdG9yLkNvbm5lY3RvciIrChNHZXRDb25uZWN0b3JSZXF1ZXN0EhQKDGNvbm5lY3Rvcl9pZBgBIAEoCSJEChFDb25uZWN0b3JSZXNwb25zZRIvCgljb25uZWN0b3IYASABKAsyHC5sdmRyLnYyLmNvbm5lY3Rvci5Db25uZWN0b3IibwoZU3RvcmVDb25uZWN0b3JBdXRoUmVxdWVzdBIUCgxjb25uZWN0b3JfaWQYASABKAkSPAoLY3JlZGVudGlhbHMYAiABKAsyJy5sdmRyLnYyLmNvbm5lY3Rvci5Db25uZWN0b3JDcmVkZW50aWFscyIyChpSZXZva2VDb25uZWN0b3JBdXRoUmVxdWVzdBIUCgxjb25uZWN0b3JfaWQYASABKAkiQAoVQ29ubmVjdG9yQXV0aFJlc3BvbnNlEhQKDGNvbm5lY3Rvcl9pZBgBIAEoCRIRCgljb25uZWN0ZWQYAiABKAgiNQodR2V0Q29ubmVjdG9yQXV0aFN0YXR1c1JlcXVlc3QSFAoMY29ubmVjdG9yX2lkGAEgASgJIlgKG0Nvbm5lY3RvckF1dGhTdGF0dXNSZXNwb25zZRIUCgxjb25uZWN0b3JfaWQYASABKAkSEQoJY29ubmVjdGVkGAIgASgIEhAKCGxvY2F0aW9uGAMgASgJIkAKFU1vdmVDb25uZWN0aW9uUmVxdWVzdBIUCgxjb25uZWN0b3JfaWQYASABKAkSEQoJZGlyZWN0aW9uGAIgASgJIkAKFk1vdmVDb25uZWN0aW9uUmVzcG9uc2USFAoMY29ubmVjdG9yX2lkGAEgASgJEhAKCGxvY2F0aW9uGAIgASgJIiwKFFRlc3RDb25uZWN0b3JSZXF1ZXN0EhQKDGNvbm5lY3Rvcl9pZBgBIAEoCSI3ChVUZXN0Q29ubmVjdG9yUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBINCgVlcnJvchgCIAEoCUIqWihnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvY29ubmVjdG9yYgZwcm90bzM");

/**
 * ParamMetadata describes a single action parameter.
 *
 * @generated from message lvdr.v2.connector.ConnectorParam
 */
export type ConnectorParam = Message<"lvdr.v2.connector.ConnectorParam"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: bool required = 3;
   */
  required: boolean;
};

/**
 * Describes the message lvdr.v2.connector.ConnectorParam.
 * Use `create(ConnectorParamSchema)` to create a new message.
 */
export const ConnectorParamSchema: GenMessage<ConnectorParam> = /*@__PURE__*/
  messageDesc(file_connector_connector, 0);

/**
 * ActionMetadata describes one action the connector supports.
 *
 * @generated from message lvdr.v2.connector.ConnectorAction
 */
export type ConnectorAction = Message<"lvdr.v2.connector.ConnectorAction"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated lvdr.v2.connector.ConnectorParam params = 3;
   */
  params: ConnectorParam[];
};

/**
 * Describes the message lvdr.v2.connector.ConnectorAction.
 * Use `create(ConnectorActionSchema)` to create a new message.
 */
export const ConnectorActionSchema: GenMessage<ConnectorAction> = /*@__PURE__*/
  messageDesc(file_connector_connector, 1);

/**
 * ConnectorMetadata describes a connector for the registry/UI. No secrets.
 *
 * @generated from message lvdr.v2.connector.Connector
 */
export type Connector = Message<"lvdr.v2.connector.Connector"> & {
  /**
   * e.g. "slack", "github"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * "oauth2" | "api_key" | "smtp" | "none"
   *
   * @generated from field: string auth_type = 4;
   */
  authType: string;

  /**
   * @generated from field: repeated lvdr.v2.connector.ConnectorAction actions = 5;
   */
  actions: ConnectorAction[];
};

/**
 * Describes the message lvdr.v2.connector.Connector.
 * Use `create(ConnectorSchema)` to create a new message.
 */
export const ConnectorSchema: GenMessage<Connector> = /*@__PURE__*/
  messageDesc(file_connector_connector, 2);

/**
 * ConnectorCredentials carries secrets over the WS channel. The union of
 * fields is intentionally flat (matches internal/workflow/connectors.Credentials);
 * which fields are populated depends on auth_type. Never echoed back on reads —
 * auth status only reports connected/not-connected.
 *
 * @generated from message lvdr.v2.connector.ConnectorCredentials
 */
export type ConnectorCredentials = Message<"lvdr.v2.connector.ConnectorCredentials"> & {
  /**
   * required: "oauth2" | "api_key" | "smtp" | "none"
   *
   * @generated from field: string auth_type = 1;
   */
  authType: string;

  /**
   * OAuth2:
   *
   * @generated from field: string access_token = 2;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 3;
   */
  refreshToken: string;

  /**
   * API key:
   *
   * @generated from field: string api_key = 4;
   */
  apiKey: string;

  /**
   * SMTP:
   *
   * @generated from field: string smtp_host = 5;
   */
  smtpHost: string;

  /**
   * @generated from field: int32 smtp_port = 6;
   */
  smtpPort: number;

  /**
   * @generated from field: string smtp_username = 7;
   */
  smtpUsername: string;

  /**
   * @generated from field: string smtp_password = 8;
   */
  smtpPassword: string;
};

/**
 * Describes the message lvdr.v2.connector.ConnectorCredentials.
 * Use `create(ConnectorCredentialsSchema)` to create a new message.
 */
export const ConnectorCredentialsSchema: GenMessage<ConnectorCredentials> = /*@__PURE__*/
  messageDesc(file_connector_connector, 3);

/**
 * --- List connectors (metadata only) ---
 *
 * @generated from message lvdr.v2.connector.ListConnectorsRequest
 */
export type ListConnectorsRequest = Message<"lvdr.v2.connector.ListConnectorsRequest"> & {
};

/**
 * Describes the message lvdr.v2.connector.ListConnectorsRequest.
 * Use `create(ListConnectorsRequestSchema)` to create a new message.
 */
export const ListConnectorsRequestSchema: GenMessage<ListConnectorsRequest> = /*@__PURE__*/
  messageDesc(file_connector_connector, 4);

/**
 * @generated from message lvdr.v2.connector.ListConnectorsResponse
 */
export type ListConnectorsResponse = Message<"lvdr.v2.connector.ListConnectorsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.connector.Connector connectors = 1;
   */
  connectors: Connector[];
};

/**
 * Describes the message lvdr.v2.connector.ListConnectorsResponse.
 * Use `create(ListConnectorsResponseSchema)` to create a new message.
 */
export const ListConnectorsResponseSchema: GenMessage<ListConnectorsResponse> = /*@__PURE__*/
  messageDesc(file_connector_connector, 5);

/**
 * --- Get single connector ---
 *
 * @generated from message lvdr.v2.connector.GetConnectorRequest
 */
export type GetConnectorRequest = Message<"lvdr.v2.connector.GetConnectorRequest"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;
};

/**
 * Describes the message lvdr.v2.connector.GetConnectorRequest.
 * Use `create(GetConnectorRequestSchema)` to create a new message.
 */
export const GetConnectorRequestSchema: GenMessage<GetConnectorRequest> = /*@__PURE__*/
  messageDesc(file_connector_connector, 6);

/**
 * @generated from message lvdr.v2.connector.ConnectorResponse
 */
export type ConnectorResponse = Message<"lvdr.v2.connector.ConnectorResponse"> & {
  /**
   * @generated from field: lvdr.v2.connector.Connector connector = 1;
   */
  connector?: Connector | undefined;
};

/**
 * Describes the message lvdr.v2.connector.ConnectorResponse.
 * Use `create(ConnectorResponseSchema)` to create a new message.
 */
export const ConnectorResponseSchema: GenMessage<ConnectorResponse> = /*@__PURE__*/
  messageDesc(file_connector_connector, 7);

/**
 * --- Store credentials for current user ---
 *
 * @generated from message lvdr.v2.connector.StoreConnectorAuthRequest
 */
export type StoreConnectorAuthRequest = Message<"lvdr.v2.connector.StoreConnectorAuthRequest"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;

  /**
   * @generated from field: lvdr.v2.connector.ConnectorCredentials credentials = 2;
   */
  credentials?: ConnectorCredentials | undefined;
};

/**
 * Describes the message lvdr.v2.connector.StoreConnectorAuthRequest.
 * Use `create(StoreConnectorAuthRequestSchema)` to create a new message.
 */
export const StoreConnectorAuthRequestSchema: GenMessage<StoreConnectorAuthRequest> = /*@__PURE__*/
  messageDesc(file_connector_connector, 8);

/**
 * --- Revoke credentials for current user ---
 *
 * @generated from message lvdr.v2.connector.RevokeConnectorAuthRequest
 */
export type RevokeConnectorAuthRequest = Message<"lvdr.v2.connector.RevokeConnectorAuthRequest"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;
};

/**
 * Describes the message lvdr.v2.connector.RevokeConnectorAuthRequest.
 * Use `create(RevokeConnectorAuthRequestSchema)` to create a new message.
 */
export const RevokeConnectorAuthRequestSchema: GenMessage<RevokeConnectorAuthRequest> = /*@__PURE__*/
  messageDesc(file_connector_connector, 9);

/**
 * Shared response shape for store/revoke — "connected" is authoritative after
 * the mutation. revoke → false; store → true.
 *
 * @generated from message lvdr.v2.connector.ConnectorAuthResponse
 */
export type ConnectorAuthResponse = Message<"lvdr.v2.connector.ConnectorAuthResponse"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;

  /**
   * @generated from field: bool connected = 2;
   */
  connected: boolean;
};

/**
 * Describes the message lvdr.v2.connector.ConnectorAuthResponse.
 * Use `create(ConnectorAuthResponseSchema)` to create a new message.
 */
export const ConnectorAuthResponseSchema: GenMessage<ConnectorAuthResponse> = /*@__PURE__*/
  messageDesc(file_connector_connector, 10);

/**
 * --- Get auth status (no secrets) ---
 *
 * @generated from message lvdr.v2.connector.GetConnectorAuthStatusRequest
 */
export type GetConnectorAuthStatusRequest = Message<"lvdr.v2.connector.GetConnectorAuthStatusRequest"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;
};

/**
 * Describes the message lvdr.v2.connector.GetConnectorAuthStatusRequest.
 * Use `create(GetConnectorAuthStatusRequestSchema)` to create a new message.
 */
export const GetConnectorAuthStatusRequestSchema: GenMessage<GetConnectorAuthStatusRequest> = /*@__PURE__*/
  messageDesc(file_connector_connector, 11);

/**
 * @generated from message lvdr.v2.connector.ConnectorAuthStatusResponse
 */
export type ConnectorAuthStatusResponse = Message<"lvdr.v2.connector.ConnectorAuthStatusResponse"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;

  /**
   * @generated from field: bool connected = 2;
   */
  connected: boolean;

  /**
   * "private" | "always_on" | "" (not connected) — AON-06
   *
   * @generated from field: string location = 3;
   */
  location: string;
};

/**
 * Describes the message lvdr.v2.connector.ConnectorAuthStatusResponse.
 * Use `create(ConnectorAuthStatusResponseSchema)` to create a new message.
 */
export const ConnectorAuthStatusResponseSchema: GenMessage<ConnectorAuthStatusResponse> = /*@__PURE__*/
  messageDesc(file_connector_connector, 12);

/**
 * --- AON-06: move a connection between Private and the always-on space ---
 *
 * @generated from message lvdr.v2.connector.MoveConnectionRequest
 */
export type MoveConnectionRequest = Message<"lvdr.v2.connector.MoveConnectionRequest"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;

  /**
   * "in" (Private -> always-on space) | "out" (space -> Private)
   *
   * @generated from field: string direction = 2;
   */
  direction: string;
};

/**
 * Describes the message lvdr.v2.connector.MoveConnectionRequest.
 * Use `create(MoveConnectionRequestSchema)` to create a new message.
 */
export const MoveConnectionRequestSchema: GenMessage<MoveConnectionRequest> = /*@__PURE__*/
  messageDesc(file_connector_connector, 13);

/**
 * @generated from message lvdr.v2.connector.MoveConnectionResponse
 */
export type MoveConnectionResponse = Message<"lvdr.v2.connector.MoveConnectionResponse"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;

  /**
   * "private" | "always_on" — where the connection is after the move
   *
   * @generated from field: string location = 2;
   */
  location: string;
};

/**
 * Describes the message lvdr.v2.connector.MoveConnectionResponse.
 * Use `create(MoveConnectionResponseSchema)` to create a new message.
 */
export const MoveConnectionResponseSchema: GenMessage<MoveConnectionResponse> = /*@__PURE__*/
  messageDesc(file_connector_connector, 14);

/**
 * --- Test connection ---
 *
 * @generated from message lvdr.v2.connector.TestConnectorRequest
 */
export type TestConnectorRequest = Message<"lvdr.v2.connector.TestConnectorRequest"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;
};

/**
 * Describes the message lvdr.v2.connector.TestConnectorRequest.
 * Use `create(TestConnectorRequestSchema)` to create a new message.
 */
export const TestConnectorRequestSchema: GenMessage<TestConnectorRequest> = /*@__PURE__*/
  messageDesc(file_connector_connector, 15);

/**
 * @generated from message lvdr.v2.connector.TestConnectorResponse
 */
export type TestConnectorResponse = Message<"lvdr.v2.connector.TestConnectorResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * empty on success
   *
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message lvdr.v2.connector.TestConnectorResponse.
 * Use `create(TestConnectorResponseSchema)` to create a new message.
 */
export const TestConnectorResponseSchema: GenMessage<TestConnectorResponse> = /*@__PURE__*/
  messageDesc(file_connector_connector, 16);

